import {NavItem, NavLink} from 'mdbreact';
import React from 'react';

const ItemDeNavBar = (props) => 
  <NavItem active = {props.activo ? 'active' : ''}  >
    <NavLink className='nav-link'   to={props.ruta} onClick = {() => props.onClick()}>

      {props.texto }
    
    </NavLink>  
  </NavItem>


export default ItemDeNavBar 


// WEBPACK FOOTER //
// ./src/componentes/ItemDeNavBar.js